import { render, staticRenderFns } from "./CellContentDisplayer.vue?vue&type=template&id=ace68bce&scoped=true&"
import script from "./CellContentDisplayer.vue?vue&type=script&lang=js&"
export * from "./CellContentDisplayer.vue?vue&type=script&lang=js&"
import style0 from "./CellContentDisplayer.vue?vue&type=style&index=0&id=ace68bce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace68bce",
  null
  
)

export default component.exports